import { useAudio } from "@/components/audio-provider";
import { cn } from "@/lib/utils";

export const SPEED_PRESETS = [
  { rate: 0.5, label: "Demon" },
  { rate: 0.75, label: "Drunk" },
  { rate: 1, label: "Normal" },
  { rate: 1.25, label: "Gremlin" },
  { rate: 1.5, label: "Hyper" },
  { rate: 2, label: "Chipmunk" },
];

/**
 * Playback-speed presets + fine slider, wired to the global playbackRate in
 * the audio provider. Shared by the header Playback panel and the per-sound
 * permalink page so there's a single source of truth for the lab.
 */
export function SpeedControl({ className }: { className?: string }) {
  const { playbackRate, setPlaybackRate } = useAudio();

  return (
    <div className={className}>
      <div className="mb-2 flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-wider text-fog">Speed</span>
        <span className="font-mono text-xs font-semibold text-spark">{playbackRate}×</span>
      </div>
      <div className="mb-3 grid grid-cols-3 gap-1.5">
        {SPEED_PRESETS.map((p) => (
          <button
            key={p.rate}
            onClick={() => setPlaybackRate(p.rate)}
            className={cn(
              "rounded-lg px-1 py-1.5 text-center transition-colors",
              playbackRate === p.rate ? "bg-spark text-ink" : "bg-mist/30 text-parchment hover:bg-mist/60",
            )}
          >
            <div className="font-mono text-xs font-semibold leading-tight">{p.rate}×</div>
            <div className="text-[9px] leading-tight opacity-70">{p.label}</div>
          </button>
        ))}
      </div>
      <input
        type="range"
        min={0.5}
        max={2}
        step={0.05}
        value={playbackRate}
        onChange={(e) => setPlaybackRate(Number(e.target.value))}
        aria-label="Playback speed"
        className="w-full cursor-pointer accent-spark"
      />
    </div>
  );
}
